import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

export const richTextToPlainTextString = (richText) => {
  if (!richText?.raw) return "";

  return documentToPlainTextString(
    (typeof richText.raw === "string" ? JSON.parse(richText.raw) : richText.raw)
  );
}
